export type DocumentUserIndexType = (typeof DocumentUserIndexType)[keyof typeof DocumentUserIndexType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentUserIndexType = {
  IDCustomer: 'IDCustomer',
  CustomerCode: 'CustomerCode',
  IDServiceRequest: 'IDServiceRequest',
  IDOrder: 'IDOrder',
  IDBusinessCase: 'IDBusinessCase',
  taxDocumentNumber: 'taxDocumentNumber',
  ContractNumber: 'ContractNumber',
  PersonalID: 'PersonalID',
  Visible: 'Visible',
  otherIndex: 'otherIndex',
} as const;
